module.exports = __webpack_public_path__ + "media/prk/assets/images/icons/text-field-34e7071aa8f166a904dc6ae83d853234.svg";